import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getFacilitiesImages($hapimagResortId: Int!, $locale: String!){
    resortCollection(where:{hapimagResortId: $hapimagResortId}, locale: $locale){
    items{
        resortName,
        resortImagesCollection{
            items{
                title,
                url,
                sys {
                    id
                }
            }
        },
        sys {
            id
        }
    }
  }
}`;

export const getFacilitiesImages = (hapimagResortId) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const { loading, error, data } = useQuery(QUERY, {
        variables: { hapimagResortId, locale: localeUppercase },
        errorPolicy: "all"
    });
    const facilities = data?.resortCollection?.items;
    return {
        facilities,
        loading,
        error
    };
};
